<div class="footer-container">
    <div class="footer-content">
        <div class="d-flex">
            <a href="https://www.facebook.com/WINGS.ICT/" class="btn btn-floating animated-btn" role="button"
                target="_blank">
                <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com/i/flow/login?redirect_after_login=%2Fwings_ict"
                class="btn btn-floating animated-btn" role="button" target="_blank">
                <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/company/wings-ict-solutions" class="btn btn-floating animated-btn"
                role="button">
                <i class="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCPotWFhjcmvgQAbBYMYhofQ" class="btn btn-floating animated-btn"
                role="button" target="_blank">
                <i class="fab fa-youtube"></i>
            </a>
        </div>
        <div class="logos">
            <a href="https://www.wings-ict-solutions.eu/" target="_blank">
                <img src="../../../assets/img/wingslogo.png" alt="WINGS Logo">
            </a>
        </div>
        <div>
            <h3>Copyright © 2024 WINGS ICT SOLUTIONS</h3>
        </div>
    </div>
</div>